export default "__VITE_ASSET__96587647__$_?nuxt_component=async__"